(function (global, factory) {
    factory(require('jquery'))
}(this, (function ($) { 'use strict';

    global.YTVideo = {
        options: {
            modal: null,
        },
        modal: {
            show: function () {
                setTimeout(() => {
                    (new bootstrap.Modal(this.options.modal)).show()
                }, 2000)
            },
            resize: function () {
                if (bootstrap.Modal.getInstance(this.options.modal)) {
                    const video = this.options.modal.querySelector('[id="yt-video"]')
                    video.height = video.offsetWidth * 9 / 16
                }
            }
        },
        init: function () {
            this.options.modal = document.getElementById('modal-youtube-video')
            this.options.modal.addEventListener('shown.bs.modal', () => window.dispatchEvent(new Event('resize')))
            window.addEventListener('resize', this.modal.resize.bind(this))
            window.addEventListener('load', this.modal.show.bind(this))
        }
    };

})));
